import * as React from "react";
import { Button } from "@material-ui/core";

export default function CustomizedDialog({ searchValue, searchPlayers }) {
    const isDisabled = !searchValue || searchValue.length === 0;
    const buttonStyle = {
        backgroundColor: isDisabled
            ? "var(--primary-button-disabled-background-color, #5d5d5d)"
            : "var(--primary-button-background-color, var(--primary-theme-color))",
        color: isDisabled
            ? "var(--primary-button-disabled-text-color, #ffffff)"
            : "var(--primary-button-text-color, #000000)",
        opacity: isDisabled ? 0.5 : 1,
        textTransform: "none",
        fontFamily: "Poppins",
        fontSize: "11px",
        whiteSpace: "nowrap",
        cursor: isDisabled ? "not-allowed" : "pointer",
    };

    return (
        <div>
            <Button
                variant="contained"
                disabled={isDisabled}
                style={buttonStyle}
                onClick={() => {
                    if (searchValue && searchValue.length > 0) {
                        searchPlayers("asc", "full_name");
                    }
                }}
            >
                Search
            </Button>
        </div>
    );
}
